// extracted by mini-css-extract-plugin
module.exports = {"arrow":"BackLink__arrow"};